import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mock';

export default function FAQSection() {
  return (
    <section id="faqs" className="relative py-24 md:py-28 text-white" style={{background: 'linear-gradient(180deg, #030303 0%, #000 100%)'}}>
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-[10px] tracking-[0.4em] text-[#00F0FF] font-semibold uppercase mb-4 font-mono">? Answers</div>
          <h2 className="font-display text-4xl md:text-6xl font-black tracking-[-0.03em] text-white">
            Frequently{' '}
            <span className="italic bg-clip-text text-transparent bg-gradient-to-r from-[#00F0FF] to-[#FF007F]">
              asked questions
            </span>
          </h2>
        </div>
        <Accordion type="single" collapsible className="mt-10">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
              <AccordionTrigger className="text-left text-[16px] font-semibold text-white hover:no-underline py-5 hover:text-[#00F0FF]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
